





















import { Component, Vue } from "vue-property-decorator";
import firebase from "firebase";
@Component<WarningONP>({})
export default class WarningONP extends Vue {
  private IsTurned = false;
  mounted(): void {
    this.IsTurned = false;
    if (document.documentElement.clientHeight > document.documentElement.clientWidth) {
      this.$router.replace("/onp");
      location.reload();
      return;
    }
    window.addEventListener("orientationchange", () => {
      var afterOrientationChange = () => {
        if (this.IsTurned) return;
        if (
          document.documentElement.clientHeight >
          document.documentElement.clientWidth
        ) {
          this.IsTurned = true;
          this.$router.replace("/onp");
          location.reload();
        }
        window.removeEventListener("resize", afterOrientationChange);
      };
      window.addEventListener("resize", afterOrientationChange);
    });
  }
}
